.icon {
  display: inline-block;
  height: 1.5rem;
  vertical-align: middle;
  width: 1.5rem;
}
